import React, { useState } from "react";

function Login({ setUser }) {
  const [name, setName] = useState("");

  const handleLogin = () => {
    if (!name) {
      alert("Name enter kara");
      return;
    }
    localStorage.setItem("currentUser", name);
    setUser(name);
  };

  return (
    <div>
      <h2>Enter Your Name</h2>
      <input
        type="text"
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <br /><br />
      <button onClick={handleLogin}>Start Game</button>
    </div>
  );
}

export default Login;
